import npLogo from "../../assets/images/npLogoWhite.svg";
import { Link } from "react-router-dom";

const footerLinks = [
    { href: "/privacy-policy", label: "Privacy Policy" },
    { href: "/terms-and-conditions", label: "Terms and Conditions" },
    { href: "https://npsolved.com/contact", label: "Sell Tickets" },
    { href: "/login", label: "Organiser Login" },
];

export default function Footer() {
    return (
        <footer className="lg:col-span-2 bg-black px-6 py-10 text-white lg:px-20">
            <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 text-center md:flex-row md:justify-between md:text-left">
                <div className="flex flex-col items-center gap-4 md:items-start">
                    <a href="https://npsolved.com">
                        <img
                            src={npLogo}
                            alt="Tickets.NP"
                            className="w-36 object-contain"
                        />
                    </a>

                    <p className="max-w-sm text-sm leading-6 text-white/60">
                        Hard Problems, Complete Solutions, Solved by us.
                    </p>
                </div>

                <nav aria-label="Footer navigation">
                    <ul className="grid gap-3 text-sm text-white/70 sm:grid-cols-2 md:text-right">
                        {footerLinks.map((link) => (
                            <li key={link.href}>
                                <Link
                                    to={link.href}
                                    className="underline-offset-4 transition-colors hover:text-white hover:underline"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>

            <div className="mx-auto mt-8 max-w-7xl border-t border-white/10 pt-6 text-center md:text-left">
                <p className="text-xs text-white/40">
                    © {new Date().getFullYear()} np Solved Software. All rights reserved.
                </p>
            </div>
        </footer>
    );
}